import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import CustomSvg from './BaseIcon';
const MinusIcon = ({ className, testId = 'minusIcon', color, }) => {
    const { colors } = useTheme();
    const iconColor = color ? color : colors.interactive.brandColor;
    return (_jsx(CustomSvg, { className: className, "data-cy": testId, width: "17", height: "3", viewBox: "0 0 17 3", fill: "none", children: _jsx("path", { d: "M1 1.5H16", stroke: iconColor, strokeWidth: "1.7", strokeLinecap: "round" }) }));
};
export default MinusIcon;
//# sourceMappingURL=MinusIcon.js.map